"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Simple utility to set the query parameters on the current page.
 *
 * Copyright (C) 2017D Noom, Inc.
 * @author Hubert
*/
var setQuery = function setQuery(history, query) {
  var current = location.search.length > 1 ? (0, _lodash["default"])(location.search.substr(1).split("&")).map(function (item) {
    return item.split("=");
  }).fromPairs().value() : {};

  _lodash["default"].assign(current, query);

  var querystring = "?" + (0, _lodash["default"])(current).map(function (v, k) {
    return v === null || v === undefined || v === "" ? null : "".concat(k, "=").concat(encodeURIComponent(v));
  }).filter().value().join("&");
  history.push("".concat(location.pathname).concat(querystring).concat(location.hash));
};

var _default = setQuery;
exports["default"] = _default;